export default "__VITE_ASSET__DRmubMkR__"